import { useState, type Ref, type ChangeEvent } from 'react';
import classnames from 'classnames';
import Error from './Error';
import Label from './Label';
import type { FormError } from './types';

interface NumberProps {
  activeField?: string | null;
  clearField: () => void;
  error?: FormError;
  formatter?: (v: string | number) => string | number;
  label?: string;
  name: string;
  onChange: (value: string) => void;
  onFocus: () => void;
  placeholder?: string | null;
  ref?: Ref<HTMLInputElement>;
  testId?: string;
  value?: string | number;
}

const Number = ({
  activeField,
  clearField,
  error,
  formatter = (v) => v,
  label,
  name,
  onChange,
  onFocus,
  placeholder = null,
  ref,
  testId = '',
  value,
}: NumberProps) => {
  const [formattedValue, setFormattedValue] = useState(formatter(value ?? ''));

  const onBlur = () => {
    setFormattedValue(formatter(value ?? ''));
    clearField();
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value.replace(/[^0-9.]/g, ''));
  };

  return (
    <div className="form-group">
      <Label name={name}>{label}</Label>
      <input
        className={classnames('form-control', { 'is-invalid': error })}
        data-testid={testId}
        id={name}
        name={name}
        onBlur={onBlur}
        onChange={handleChange}
        onFocus={onFocus}
        placeholder={placeholder as string | undefined}
        ref={ref}
        type="text"
        value={activeField === name ? (value ?? '') : value ? formattedValue : ''}
      />
      <Error>{error?.message}</Error>
    </div>
  );
};

export default Number;
